import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
//
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../hooks/useModulePublic";
import { StoreContext } from "../../../../../../store/StoreProvider";
import CommonListItem from "../../common/CommonListItem";
import CommonList from "../../common/CommonList";
//
import Act from "../../../../../../store/actions";
import urls from "../../../../../../api/project/ApiUrls";
import { isNumeric } from "../../../../../../common/utils";
//
import { EVENT_TYPE_CLASS } from "../../../../../../config/config.sna";
import EventCategoryDialog from "./EventCategoryDialog";

const popupMenuPosition = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
};

const StyledList = CommonList;

const AccordionDetailChildren = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  // @ts-ignore
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale, group } = user;
  const { filter, dataset } = sna;
  const { eventTypes, filterEventTypeOn } = filter;
  // local state
  const [filterOn, setFilterOn] = useState(false);
  const [refrsListSignal, setRefrsListSignal] = useState(null);
  const [listItems, setListItems] = useState(eventTypes.change || []);
  const [listItemFocus, setListItemFocus] = useState(null);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  useEffect(() => {
    setFilterOn(filterEventTypeOn.change);
  }, [filterEventTypeOn]);

  useEffect(() => {
    // 篩選的日誌若變更,則變更 listItems 的 property 狀態
    setRefrsListSignal(Date.now());
  }, [dataset.public]);

  useEffect(() => {
    if (Array.isArray(eventTypes.change)) {
      // 檢查目前選擇的開放資料集是否有要開放林獻堂親屬關係
      const dataPubCheck = dataset.public
        // @ts-ignore
        .filter((dt) => dt.checked);

      const newListItem = eventTypes.change.map((o) => {
        let displayed;
        // 若是基本事件類別設定,一律顯示
        if (o.type === EVENT_TYPE_CLASS.EventType) {
          displayed = true;
        } else {
          displayed = !!dataPubCheck.find(
            // [diary,diary_cph]
            // @ts-ignore
            (p) => (p.kinshipGraph || "").split(",").includes(o.kinshipGraph)
          );
        }

        return {
          ...o,
          displayed,
        };
      });
      setListItems(newListItem);
      //
      dispatch({
        type: Act.SNA_EVENT_TYPES_CHANGE,
        payload: newListItem,
      });
      dispatch({
        type: Act.SNA_EVENT_TYPES_INITIAL,
        payload: newListItem,
      });
    }
  }, [refrsListSignal]);

  /**
   *
   * @param e {React.ChangeEvent}
   * @param listItem {import('../../../../SnaPage').EventType}
   */

  /**
   * 是否開啟事件分類功能
   * @param e {React.ChangeEvent}
   */
  const handleFilterOn = (e) => {
    // @ts-ignore
    const { checked } = e.target;
    setFilterOn(checked);
    dispatch({
      type: Act.SNA_EVENT_TYPES_FILTER_ON_CHANGE,
      payload: checked,
    });
  };

  /**
   * 利用 step value(0,1,2) 來縮排 listItem,呈現階層式的排列
   * @param item {import('../../../../SnaPage').EventType}
   * @returns {{}|{"&.MuiListItem-root": {left: string}}}
   */

  return (
    <StyledList>
      <CommonListItem
        withCheckbox
        withAvatar={false}
        checked={filterOn}
        onCheckboxChange={handleFilterOn}
        context={{
          textPrimary: "啟用事件分類功能",
        }}
        avatarSize="normal"
        darkMode
        listItemStyle={{
          "&.MuiListItem-root": {
            left: "-20px",
          },
        }}
      />
      <EventCategoryDialog />
    </StyledList>
  );
};

export default AccordionDetailChildren;
